import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroBanner = () => {
  const navigate = useNavigate();

  const handleShopNow = () => {
    navigate('/product-catalog');
  };

  return (
    <section data-ocwp-field="heroImage" className="relative min-h-[80vh] sm:min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-primary/20 via-background to-accent/20 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: "url('/hero.png')" }}>
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, currentColor 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }} />
      </div>
      {/* Floating Style Elements */}
      <motion.div
        animate={{
          y: [0, -20, 0],
          rotate: [0, 5, 0]
        }}
        transition={{
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut"
        }}
        className="absolute top-20 left-10 w-20 h-20 bg-primary/20 rounded-full blur-xl"
      />
      <motion.div
        animate={{
          y: [0, 20, 0],
          rotate: [0, -5, 0]
        }}
        transition={{
          duration: 5,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 1
        }}
        className="absolute bottom-32 right-20 w-32 h-32 bg-accent/20 rounded-full blur-xl"
      />
      {/* Content */}
      <div className="relative z-10 mx-6 max-w-sm sm:mx-auto sm:max-w-3xl bg-white/65 backdrop-blur-md rounded-2xl shadow-lg p-4 sm:p-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-3xl sm:text-5xl md:text-7xl font-heading font-bold text-foreground mb-4 sm:mb-6 leading-tight">
            Discover Your
            <span className="block text-primary mt-2">
              Effortless Style
            </span>
          </h1>
          <p className="text-base sm:text-xl md:text-2xl text-muted-foreground mb-6 sm:mb-8 max-w-3xl mx-auto">
            Curated premium fashion items from world-class brands. Experience curated dresses, tops, outerwear and accessories.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <Button
            onClick={handleShopNow}
            size="lg"
            className="px-8 py-4 text-lg group"
          >
            Shop Now
            <Icon name="ArrowRight" size={20} className="ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
          <Button
            onClick={() => navigate('/product-catalog')}
            variant="outline"
            size="lg"
            className="px-8 py-4 text-lg"
          >
            Explore Collection
          </Button>
        </motion.div>

        {/* Trust Badges */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-16 flex flex-wrap items-center justify-center gap-8 text-muted-foreground"
        >
          <div className="flex items-center gap-2">
            <Icon name="Shield" size={24} className="text-primary" />
            <span className="text-sm font-medium">100% Authentic</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Truck" size={24} className="text-primary" />
            <span className="text-sm font-medium">Free Shipping</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Award" size={24} className="text-primary" />
            <span className="text-sm font-medium">Expert Curated</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Heart" size={24} className="text-primary" />
            <span className="text-sm font-medium">Customer Loved</span>
          </div>
        </motion.div>
      </div>
      {/* Scroll Indicator */}
      <motion.div
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
      >
        <Icon name="ChevronDown" size={32} className="text-muted-foreground" />
      </motion.div>
    </section>
  );
};

export default HeroBanner;